import { render, staticRenderFns } from "./InstanceTableItemSkeleton.vue?vue&type=template&id=7f0cc196&scoped=true"
import script from "./InstanceTableItemSkeleton.vue?vue&type=script&lang=js"
export * from "./InstanceTableItemSkeleton.vue?vue&type=script&lang=js"
import style0 from "./InstanceTableItemSkeleton.vue?vue&type=style&index=0&id=7f0cc196&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0cc196",
  null
  
)

export default component.exports